<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a
          class="nav-link"
          href="#/Mlyny"
          :class="{ active: tabName == 'Mills' }"
          >Młyny</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          href="#/KuwerturyNaPolce"
          :class="{ active: tabName == 'DisplayCouverturesOnShelf' }"
          >Kuwertury</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["tabName"],
};
</script>